import { useSelector } from 'react-redux';
import { useCallback } from 'react';
import { RootState } from 'store/store';
import { translate } from 'services/translationService';
import { LocaleVariables } from 'store/slices/localesSlice';
import { useLocalization } from 'contexts/LocalizationContext';

export const useTranslation = () => {
  const { currentLocale, changeLocale, availableLocales } = useLocalization();
  const { locales } = useSelector((state: RootState) => state.locales);

  const t = useCallback(
    (
      slug: string,
      file: string = '_global',
      fallback: string = '',
      variables: LocaleVariables | null = null
    ): string => {
      // ensure dependencies are used to satisfy exhaustive-deps
      void currentLocale;
      void locales;
      return translate(slug, file, fallback, variables);
    },
    [currentLocale, locales]
  );

  return {
    t, // Main translation function
    translate: t, // Alias for consistency
    currentLocale,
    changeLocale,
    availableLocales,
    locales,
  };
};
